import translate from '@/utils/translate';
import type {SearchState} from '@/types/models/creator-crm/creatorCrm';
import type {GroupedDisplayItems} from './displayItemTypes';

const SEARCH_TYPE_LABEL: Record<SearchState['type'], string> = {
  all: 'All',
  content: 'Content',
  bio: 'Bio',
  handle: 'Name',
};

/**
 * Converts search state (All, Content, Bio, Name chips) to GroupedDisplayItems[] for display.
 */
// eslint-disable-next-line import/prefer-default-export
export function groupedDisplayItemsFromSearchState(
  searchState: SearchState | undefined
): GroupedDisplayItems[] {
  if (!searchState || searchState.chips.length === 0) {
    return [];
  }
  const filterName = translate(SEARCH_TYPE_LABEL[searchState.type]);
  const groupKey = `searchState-${searchState.type}`;
  const items = searchState.chips.map((chip) => ({
    type: 'searchChip' as const,
    searchType: searchState.type,
    value: chip,
    filterName,
  }));
  return [{groupKey, items}];
}
